import React, { Component } from 'react';
import AutoCompleteModel from './AutoCompleteModel';
export default class extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
  }
  getUri(value){
    console.log('entere')
    if(value.length > 1){
      return 'titulares/buscar?s='+value;
    }
  }
  
  getValue(object){
    var value = `${object.apellido}, ${object.nombre} - DNI:${object.numeroDocumento}`;
    return value
  }
  saveRef = (obj, name) => {
    this[name] = obj;
  }

  handleError= (e)=>{ 
    console.log("e",e)
  }

  render() {
    return (
      <AutoCompleteModel 
        handleError={(e)=>{this.handleError(e)}} 
        keyData={'codigoTitular'} 
        initialValue={this.props.initialValue} 
        reloadInitial={true} 
        ref={(e) => this.saveRef(e, 'autocomplete')} 
        size={this.props.size} 
        disabled={this.props.disabled} 
        reload={true} 
        filterDefault={false} 
        onSelect={this.props.onSelect} 
        onSearch={this.props.onSearch} 
        uriFunction={this.getUri}  
        placeholder='Buscar usuario (DNI, Apellido, Banda Iso, Patente)'
        getValueFunction={this.getValue}/>
    );
  }
}

